import { gql } from 'urql';

const GetReactivationDocumentRequests = gql`
  query GetReactivationDocumentRequests($externalId: String!) {
    reactivationDocumentRequests(externalId: $externalId) {
      __typename
      id
      requests {
        id
        type
        name
        description
        mechanism
        url
        qrCode
      }
    }
  }
`;

export default GetReactivationDocumentRequests;
